import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { ActivityTypeSelectComponent } from 'src/app/_components/remote-action-step/activitytype-select/activity-type-select.component';
import { KeywordSelectComponent } from 'src/app/_components/remote-action-step/keyword-select/keyword-select.component';

@Injectable()
export class KeywordSelectRemoteActionBuilderUIStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(
      this.constructor.name,
      '- getComponent for Keyword-Select called'
    );
    return KeywordSelectComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    return true;
  }
}
